import React, { useState } from 'react';
import { ChevronDown, FileCheck2, UploadCloud, X } from 'lucide-react';
import { DragDropZone } from '../DragDropZone';

const Picker = ({ label, file, onChange, testid }) => (
  <div className="relative min-w-0 flex-1" data-testid={testid}>
    <DragDropZone
      onFileSelect={(f) => onChange(f)}
      accept=".xlsx,.csv,.numbers"
      maxSize={25 * 1024 * 1024}
      className={`!p-3 ${file ? 'border-emerald-400 bg-emerald-50/60 dark:bg-emerald-950/30' : 'border-blue-200 dark:border-blue-900/60 bg-blue-50/40 dark:bg-slate-800/40 hover:border-blue-400'}`}
      data-testid={`${testid}-input`}
    >
      <div className="flex flex-col items-center gap-1 text-center">
        {file ? <FileCheck2 className="h-5 w-5 text-emerald-600" /> : <UploadCloud className="h-5 w-5 text-blue-500" />}
        <span className="text-xs font-semibold text-slate-800 dark:text-slate-100">{label}</span>
        <span className="max-w-full truncate text-[11px] text-muted-foreground">{file ? file.name : 'Drag & drop or click · .xlsx, .csv, .numbers'}</span>
      </div>
    </DragDropZone>
    {file && (
      <button type="button" onClick={() => onChange(null)} className="absolute right-1.5 top-1.5 rounded p-1 text-slate-400 hover:bg-white/70 hover:text-slate-700" aria-label={`Remove ${label}`} data-testid={`${testid}-clear`}>
        <X className="h-3.5 w-3.5" />
      </button>
    )}
  </div>
);

/** Optional Amazon payment reports (spot + contract) used to flag which imported loads were paid. */
export const PaymentFilesPicker = ({ files, onChange }) => {
  const [open, setOpen] = useState(!!(files.spot || files.contract));
  const count = (files.spot ? 1 : 0) + (files.contract ? 1 : 0);
  return (
    <div className="rounded-lg border border-slate-200 dark:border-slate-700" data-testid="payment-files-picker">
      <button type="button" onClick={() => setOpen((o) => !o)} className="flex w-full items-center justify-between px-3 py-2 text-sm font-medium" aria-expanded={open} data-testid="payment-files-toggle">
        <span>Check payments <span className="font-normal text-muted-foreground">(optional{count ? ` · ${count} added` : ''})</span></span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="space-y-2 border-t border-slate-200 dark:border-slate-700 p-3">
          <p className="text-xs text-muted-foreground">Add Amazon's payment reports and each load will be marked <strong>Paid</strong> if its block, trip or load ID appears in either file, or <strong>Not paid</strong> if it doesn't. Amounts are not changed.</p>
          <div className="flex flex-col gap-2 sm:flex-row">
            <Picker label="Spot payment file" file={files.spot} onChange={(f) => onChange({ ...files, spot: f })} testid="payment-file-spot" />
            <Picker label="Contract payment file" file={files.contract} onChange={(f) => onChange({ ...files, contract: f })} testid="payment-file-contract" />
          </div>
        </div>
      )}
    </div>
  );
};
